export default "__VITE_ASSET__4fc4af50__"